import React, { useRef, useState } from "react";
import { doc,setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { UserAuth } from "../../context/AuthContext";
import { db } from "../..//firebase/config";
import logo from "../../logo-no-background.png"

const SignUp = () => {
  let emailRef = useRef();
  let passwordRef = useRef();
  let [error, setError] = useState("");
  let navigate = useNavigate();
  const { signup } = UserAuth();
  let submit = async () => {
    const userCreated =await signup(emailRef.current.value, passwordRef.current.value)
    if(userCreated){
      console.log(userCreated.user)
      
      const usersRef = doc(db, "users", userCreated.user.uid);
      await setDoc(usersRef,{
          isAnswered: false,
          email: userCreated.user.email,
          testTaken:false
        } , { merge: true });
        navigate("/quiz")
    }       
  };
  return (
      <div className="wrapper position-relative">
        <div className="header">
            <a className="logo" href={void(0)}>
              {/* <img width="150" src={logo} alt="" /> */}
              Adaptive Chinese Placement Test
            </a>
            <a className="right-content" href={void(0)} onClick={() => navigate("/about")}>About</a>
          </div>
        <div className="container">
        {error && <h1>{error}</h1>}
          <div className="multisteps_form position-relative overflow-hidden" id="wizard">
              <div className="row">
                <div className="col-md-12">
                    <div className="form_header_content text-center pt-4">
                        <h2>Sign Up</h2>
                        <div className="auth-form">
                          <input className="my-input" type="email" ref={emailRef} placeholder="Email"/>
                          <input className="my-input" type="password" ref={passwordRef} placeholder="Password"/>
                          <button style={{alignSelf:"center"}} className="theme-btn" onClick={() => submit()}>Sign Up</button>
                          <a style={{textDecoration:"underline", color: "blue"}} onClick={() => navigate("/")}>Already a User? Click Here to Log In</a>
                        </div>
                    </div>
                </div>
              </div>
          </div>
          </div>
        </div>
  );
};

export default SignUp;
